import { createAction, props } from '@ngrx/store';
import { Offer, OffersSource } from '../../models/offers.model';

export const loadHubOffers = createAction('[Offers] Load Hub Offers', props<{ source: OffersSource }>());
export const loadHubOffersSuccess = createAction('[Offers] Load Hub Offers Success', props<{ data: Offer[] }>());
export const loadHubOffersFailure = createAction('[Offers] Load Hub Offers Failure', props<{ error: any }>());
export const dismissHubOffer = createAction('[Offers] Dismiss Hub Offer');
export const resetHubOffers = createAction('[Offers] Reset Hub Offers');

export const loadOfferOffers = createAction('[Offers] Load Offer Offers', props<{ source: OffersSource }>());
export const loadOfferOffersSuccess = createAction('[Offers] Load Offer Offers Success', props<{ data: Offer[] }>());
export const loadOfferOffersFailure = createAction('[Offers] Load Offer Offers Failure', props<{ error: any }>());
export const dismissOfferOffers = createAction('[Offers] Dismiss Offer Offers');
export const resetOfferOffers = createAction('[Offers] Reset Offer Offers');
